module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kansai-4-62d07825dfc83cfe5407a1ad2d169726.jpg";